import { render, staticRenderFns } from "./WaterLeakageCauseLocalizedPlumberIntervenedInvoiceQuestion.vue?vue&type=template&id=0b1227db"
import script from "./WaterLeakageCauseLocalizedPlumberIntervenedInvoiceQuestion.vue?vue&type=script&lang=ts"
export * from "./WaterLeakageCauseLocalizedPlumberIntervenedInvoiceQuestion.vue?vue&type=script&lang=ts"
import style0 from "./WaterLeakageCauseLocalizedPlumberIntervenedInvoiceQuestion.vue?vue&type=style&index=0&id=0b1227db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports